
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { eventHandler, translations } from '@/mixins';
import { Menu as MenuApi, AuditLog as AuditLogApi } from '@/services/SOLO';
import { Button, Table, TableColumn } from 'element-ui';
import menuRoles from '@/directives/menuRoles';
import { mapGetters } from 'vuex';
import EditModgroupItem from '@/views/Admin/pages/Menus/pages/itemPages/modifiercomponents/EditModgroupItem';
import LoadingPanel from '@/components/LoadingPanel';
import draggable from 'vuedraggable';
import EnableDisableModifierModal from './EnableDisableModifierModal';
import AuditTable from '@/components/Audit/AuditTable.vue';
import { PublishMenuButton } from '@/components/V2/PublishMenuButton';

@Component({
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    EditModgroupItem,
    LoadingPanel,
    draggable,
    AuditTable,
    EnableDisableModifierModal,
    PublishMenuButton,
  },
  directives: {
    menuRoles,
  },
  computed: {
    ...mapGetters({
      getConceptSettings: 'account/getConceptSettings',
      userRole: 'account/getUserRole',
      getUserClient: 'account/getUserClient',
      getLocale: 'app/getLocale',
    }),
  },
  mixins: [eventHandler, translations],
})
export default class ModgroupModifiers extends Vue {
  getLocale!: any;
  public items: Array<any> = [];
  public itemsSecondary: Array<any> = [];
  loading = false
  color = 'white';
  view = 'grid';
  private arrayLang: Array<string> = [];
  getLanguages!: Function;
  total = 0;
  currentPage = 1;
  perPage = 0;
  tab = 1;
  translate!: Function;
  pageLoaded = false;
  isLoaded = false;
  list: any = [];
  getConceptSettings!: Function;
  loadingConcept = true;
  userRole!: any;
  isEnableDisableOpen = false;
  itemId: any = 0;
  getUserClient!: any;
  showGripIconItem: any = null;
  confirm!: Function;
  $notify: any;
  uploadImgItemId: any = 0;
  indexImgItemId: any = 0;
  $refs!: {
    file: any;
  };

  created () {
    if (this.$route.params.tab) {
      this.tab = Number(this.$route.params.tab);
    }
    /* @ts-ignore */
    this.arrayLang.push(this.getConceptSettings.attributes['primary-language']);
    /* @ts-ignore */
    if (this.getConceptSettings.attributes['secondary-language']) {
      /* @ts-ignore */
      this.arrayLang.push(this.getConceptSettings.attributes['secondary-language']);
    }
  }

  mounted () {
    for (const i in this.arrayLang) this.getModifierItem(this.arrayLang[i]);
  }

  onHoverCard (ind: any) {
    this.showGripIconItem = ind;
  }

  uploadImage (itemId: any, index: any) {
    this.uploadImgItemId = itemId;
    this.indexImgItemId = index;
    /* @ts-ignore */
    document.getElementById('upload').click();
  }

  filesUploadChange () {
    const formData = new FormData();
    formData.append('image', this.$refs.file.files[0]);
    MenuApi.updateModifierItem(formData, this.$route.params.modifierId, this.uploadImgItemId)
      .then((response: any) => {
        this.items[this.indexImgItemId].attributes['image-uri'] = response.data.data.attributes['image-uri'];
        this.$notify({
          title: 'UPDATES SAVED!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: 'Image have been upload successfully',
          type: 'success',
          icon: 'fas fa-check',
        });
      })
      .catch((err: any) => {
        this.$notify({
          title: 'SYSTEM ERROR!',
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: err.response.data.error.detail,
          type: 'danger',
          icon: 'fas fa-bomb',
        });
      });
  }

  sortItems () {
    const promiseArr: any = [];
    let dynamicIndex = ((this.currentPage - 1) * this.perPage) + 1;
    this.items.forEach((item: any) => {
      const form = new FormData();
      form.append('display-order', dynamicIndex.toString());
      form.append('enabled', item.attributes.enabled.toString());
      MenuApi.updateModifierItem(form, this.$route.params.modifierId, item.id);
      dynamicIndex += 1;
    });
  }

  public get isFoodics () {
    return this.getUserClient?.attributes?.label === 'Foodics Online';
  }

  findAndUpdateItem (itemId: string, action: string, value = true) {
    switch (action) {
    case 'enableDisable':
      this.items.forEach((element) => {
        if (element.id == itemId) {
          element.attributes.enabled = (value == true ? 1 : 0);
        }
      });
      break;
    case 'remove':
      this.items.forEach((element: any, index: any) => {
        if (element.id == itemId) {
          this.items.splice(index, 1);
        }
      });
      break;
    case 'includeExclude':
      this.items.forEach((element: any, index: any) => {
        if (element.id == itemId) {
          element.attributes['is-excluded'] = !value;
        }
      });
      break;
    case 'enableNonAdminModItem':
      this.items.forEach((element) => {
        if (element.id == itemId) {
          element.attributes['is-enabled-for-employee'] = true;
        }
      });
      break;
    }
  }

  private enableDisable (id: string, enabled: any, minimum: number) {
    if (minimum) {
      return;
    }

    const payload = {
      enabled: enabled,
    };
    MenuApi.updateModifierItem(payload, this.$route.params.modifierId, id)
      .then((response: any) => {
        // this.getModifierItem()
        this.findAndUpdateItem(id, 'enableDisable', payload.enabled);
      });
  }

  private enableNonAdminModItem (id: string, minimum: number) {
    if (minimum) {
      return;
    }

    const payload = {
      'schedule-disabled-hours': '__enabled__',
    };
    MenuApi.updateModifierItem(payload, this.$route.params.modifierId, id)
      .then((response: any) => {
        // this.getModifierItem()
        this.findAndUpdateItem(id, 'enableNonAdminModItem', true);
      });
  }

  enableDisableModal (open: any, itemId: string, minimum: number) {
    if (minimum) {
      return;
    }

    this.isEnableDisableOpen = !!open;
    this.itemId = itemId;

    if (!open) {
      this.items.forEach((element: any) => {
        if (element.id == itemId) {
          element.attributes['is-enabled-for-employee'] = open;
        }
      });
    }
  }

  closeModal (close: any) {
    this.isEnableDisableOpen = !!close;
  }

  private exclude (id: string, isExclude: boolean) {
    const payload: Record<string, any> = {
      'modifier-id': id,
    };
    if (!isExclude) {
      MenuApi.exludeModifierItem(payload, this.$route.params.id, this.$route.params.catId, this.$route.params.itemId, this.$route.params.modifierId)
        .then((response: any) => {
          this.findAndUpdateItem(id, 'includeExclude', isExclude);
        });
    } else {
      MenuApi.includeModifierItem(payload, this.$route.params.id, this.$route.params.catId, this.$route.params.itemId, this.$route.params.modifierId, id)
        .then((response: any) => {
          this.findAndUpdateItem(id, 'includeExclude', isExclude);
        });
    }
  }

  get deleteMsgBoxText (): string {
    return this.translate('Are you sure you want to delete this Item?');
  }

  confirmationMessageTitle (toDelete: any) {
    const h = this.$createElement;
    const message = h('div',
      {
        domProps:
        { innerHTML: this.translate('Are you sure') + ` <span class="font-weight-bold">${toDelete.attributes.name}${this.translate('?')}</span><br><br>${this.translate('Please note')}` },
      });

    return message;
  }

  async remove (item: any) {
    try {
      const isDelete = await this.confirm(this.$bvModal, this.confirmationMessageTitle(item),
        {
          title: this.translate('Please Confirm'),
          okTitle: this.translate('OK'),
          cancelTitle: this.translate('Cancel'),
          footerClass: this.getLocale === 'ar_SA' ? 'd-flex flex-row-reverse flex-gap' : '',
        },
      );
      if (isDelete) {
        await MenuApi.removeModifierItem(item.id);
        await this.findAndUpdateItem(item.id, 'remove');
        this.$notify({
          title: this.translate('MODIFIER OPTION DELETED'),
          verticalAlign: 'bottom',
          horizontalAlign: 'left',
          message: this.translate('Modifier option successfully deleted.'),
          type: 'success',
          icon: 'fas fa-check',
        });
      }
    } catch (error) {
      this.$notify({
        title: this.translate('SYSTEM ERROR!'),
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        message: this.translate('Something went wrong, please try again!'),
        type: 'danger',
        icon: 'fas fa-bomb',
      });
    }
  }

  async getModifierItem (lang = 'en-us', page: any = 1) {
    await MenuApi.getModifierItem(this.$route.params.id, this.$route.params.catId, this.$route.params.itemId, this.$route.params.modifierId, lang, page)
      .then((response: any) => {
        /* @ts-ignore */
        if (this.getConceptSettings.attributes['primary-language']) {
          if (this.getLocale.replace('_', '-').toLowerCase() == lang) {
            this.items = response.data.data;
          }
        }
        /* @ts-ignore */
        if (this.getConceptSettings.attributes['secondary-language']) {
          if (this.getLocale.replace('_', '-').toLowerCase() == lang) {
            this.itemsSecondary = response.data.data;
          }
        }
        this.total = response.data.meta.pagination.total;
        this.currentPage = response.data.meta.pagination.current_page;
        this.perPage = response.data.meta.pagination.per_page;
        this.loadingConcept = false;
      });
  }

  pageChange (data: any) {
    for (const i in this.arrayLang) this.getModifierItem(this.arrayLang[i], data);
  }

  formatDate (date: string) {
    return moment
      .utc(date, 'YYYY-MM-D hh:mm:ss')
      .locale('en-us')
      .local()
      .format('MMM D YYYY hh:mm A');
  }

  onChangeView (view: string) {
    this.view = view;
  }

  getNameSecondary (row: any) {
    const find: any = this.itemsSecondary.find((item: any) => Number(item.id) === Number(row.id));
    return find && find.attributes.name;
  }
}
